import TagsUFs from './TagsUFs';

export default TagsUFs;
